export const CRM_SEGMENTS = [
    { id: "leads", title: "Leads / Funil", description: "Potenciais clientes em negociação" },
    { id: "birthday", title: "Aniversariantes", description: "Clientes que fazem aniversário este mês" },
    { id: "active", title: "Clientes ativos", description: "Clientes com matrícula ou contrato vigente" },
    { id: "inactive", title: "Clientes inativos", description: "Sem matrícula há mais de 30 dias" },
    { id: "suspended", title: "Suspensos", description: "Contrato suspenso temporariamente" },
    { id: "canceled", title: "Cancelamentos", description: "Contrato cancelado recentemente" },
    { id: "contractsDue", title: "Vencimento de contratos", description: "Contratos vencendo em breve" },
    { id: "credit", title: "Com crédito", description: "Possuem saldo positivo" },
    { id: "debt", title: "Com saldo devedor", description: "Possuem pendências financeiras" },

]
